export const getCabinClassType = (airlineCode: string, cabinClass: string) => {
  const eco = 'Economy'
  const business = 'Business'
  const first = 'First class'

  switch (airlineCode) {
    case "_9G":
    case "9G":
    case "GALILEO":
    case "GALILEO_NDC":
    case "VN":
      if (cabinClass.toLowerCase().indexOf('economy') > -1) {
        return eco
      }

      if (cabinClass.toLowerCase().indexOf('business') > -1) {
        return business
      }
      return ''

    case "VJ":
      if (cabinClass.toLowerCase().indexOf('eco') > -1 || cabinClass.toLowerCase().indexOf('deluxe') > -1) {
        return eco
      }

      if (cabinClass.toLowerCase().indexOf('business') > -1 || cabinClass.toLowerCase().indexOf('skyboss')) {
        return business
      }
      return ''

    case "QH":
      if (cabinClass.toUpperCase().indexOf('ECONOMY') > -1) {
        return eco
      }

      if (cabinClass.toUpperCase().indexOf('BUSINESS') > -1) {
        return business
      }
      return ''

    case "VU":
      if (cabinClass.toUpperCase().indexOf('ECONOMY') > -1) {
        return eco
      }

      if (cabinClass.toUpperCase().indexOf('BUSINESS') > -1) {
        return business
      }
      return ''

    case "JQ":
      // API cabins: STARTER / STARTER PLUS / FLEX / FLEX PLUS
      // ruleNumber is compacted (JQSTARTER, JQFLEXPLUS) — match without spaces
      {
        const cabin = (cabinClass || '').toLowerCase()
        if (cabin.includes('starter') || cabin.includes('flex')) {
          return eco
        }
      }
      return ''
    case "TR":
      return eco

    default:
      break;
  }
}